// 生产计划负责人值php订单处有做判断
const types1 = [{
    key:"0",
    value:"Sales Representative"
},
{
    key:"1",
    value:"Manager"
}];

export { types1 };